import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import LiabilityWriteUpCriteria from "./LiabilityWriteUpCriteria";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { Neo } from "@singularsystems/neo-react";
import { ReportCategory } from "../ReportCategory";

@NeoReport("LiabilityWriteUp", { category: ReportCategory.InvestorReports })
export default class LiabilityWriteUpReport extends Report<LiabilityWriteUpCriteria> {

    constructor(
        private investorApiClient = AppService.get(DomainTypes.ApiClients.Investor),
        private contactApiClient = AppService.get(DomainTypes.ApiClients.Contact),
        private dataCache = AppService.get(DomainTypes.Services.DataCache)

    ) {
        super(LiabilityWriteUpCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout >
                <Neo.FormGroup bind={this.criteria.meta.entityId} select={{ itemSource: this.dataCache.entities }} />
                <Neo.FormGroup bindContext={this.criteria.meta.investorId}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.investorId}
                        bindDisplay={this.criteria.meta.investorName}
                        itemSource={this.investorApiClient.getInvestorLookups} />
                </Neo.FormGroup>
                <Neo.FormGroup bindContext={this.criteria.meta.signatory1}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.signatory1}
                        bindDisplay={this.criteria.meta.signatoryName1}
                        itemSource={this.contactApiClient.getContactLookups} />
                </Neo.FormGroup>
                <Neo.FormGroup bindContext={this.criteria.meta.signatory2}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.signatory2}
                        bindDisplay={this.criteria.meta.signatoryName2}
                        itemSource={this.contactApiClient.getContactLookups} />
                </Neo.FormGroup>
                <Neo.FormGroup bindContext={this.criteria.meta.signatory3}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.signatory3}
                        bindDisplay={this.criteria.meta.signatoryName3}
                        itemSource={this.contactApiClient.getContactLookups} />
                </Neo.FormGroup>
            </Neo.GridLayout>
        </div>;
    }
}
